
import { z } from "zod";

// Form schema
export const venueFormSchema = z.object({
  name: z.string().min(1, "Venue name is required"),
  address: z.string().min(1, "Address is required"),
  city: z.string().optional(),
  state: z.string().optional(),
  zip: z.string().optional(),
  phone: z.string().optional(),
  website: z.string().url("Please enter a valid URL").optional().or(z.literal("")),
  hours: z.string().optional(),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
  maps_link: z.string().url("Please enter a valid Google Maps URL").optional().or(z.literal("")),
});

export type VenueFormValues = z.infer<typeof venueFormSchema>;

export type VenueFormProps = {
  onSubmit: (values: VenueFormValues) => void;
  onCancel: () => void;
  initialValues?: Partial<VenueFormValues>;
};

export type Venue = {
  id: string;
  name: string;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  phone?: string | null;
  website?: string | null;
  hours?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  maps_link?: string | null;
};
